import React, { memo, useMemo, useState, useEffect, useContext } from 'react';
import {
  AzureMap,
  AzureMapDataSourceProvider,
  AzureMapFeature,
  AzureMapHtmlMarker,
  AzureMapLayerProvider,
  AzureMapsProvider,
  AzureMapPopup,
  AzureMapsContext

} from 'react-azure-maps';
import { AuthenticationType, data, HtmlMarkerOptions, SymbolLayerOptions, MapMouseEvent, PopupOptions} from 'azure-maps-control';
import { Button, Chip } from '@material-ui/core';
import { key } from '../key';
import { apiDataUIUrl } from '../projConst';
import ShowTable from '../Components/ShowTable';
import * as R from 'ramda'
import * as api from '../api/apiFunc' 
import { red } from '@material-ui/core/colors';

const point1 = new data.Position(-100.01, 45.01);
const point2 = new data.Position(-120.2, 45.1);
const point3 = new data.Position(-120.2, 50.1);
const point4 = new data.Position(-126.2, 55.1);

const setPos = (pos) => new data.Position(pos['Lng'], pos['Lat']);
const setPosPopur = (prop) => new data.Position(
  prop.data?.geometry.coordinates[0],
  prop.data?.geometry.coordinates[1]
)


const onClick = (e) => {
 // console.log('You click on: ', e);
};

function azureHtmlMapMarkerOptions(coordinates) {
  return {
    position: coordinates,
    text: 'My text',
    title: 'Title',
  };
}

const eventToMarker = [{ eventName: 'click', callback: onClick }];

const renderPoint = (marker) => {
  const rendId = Math.random();
  const name = marker.title
  const subname = marker.subTitle
  return (
    <AzureMapFeature
      key={rendId}
      id={rendId.toString()}
      type="Point"
      coordinate={marker.coord}
      properties={{
        title: name,
        subTitle: subname,
        icon: 'pin-round-blue',
        popUpProp: marker
      }}
      events={eventToMarker}
    />
  );
};

function renderHTMLPoint(coordinates) {
  const rendId = Math.random();
  return (
    <AzureMapHtmlMarker
      key={rendId}
      markerContent={<div className="pulseIcon"></div>}
      options={{ ...azureHtmlMapMarkerOptions(coordinates) }}
      events={eventToMarker}
    />
  );
}

const colorValue = () =>
  '#000000'.replace(/0/g, function () {
    return (~~(Math.random() * 16)).toString(16);
  });
const markersStandardImages = [
  `marker-black`,
  `marker-blue`,
  `marker-darkblue`,
  `marker-red`,
  `marker-yellow`,
  `pin-blue`,
  `pin-darkblue`,
  `pin-red`,
  `pin-round-blue`,
  `pin-round-darkblue`,
  `pin-round-red`,
];
const initDataMarkers = (data) => {
  const listmarks = data.reduce(
    (res, row) => {
      const newPoint = setPos(row)  
      return [...res, { coord: newPoint, title: `${row.StationName}` , subTitle: `(↓В: ${row.incomeCount} / ↑И: ${row.outgoingCount}) `, code: row.StationCode, Lat: row.Lat, Lng: row.Lng, name: row.StationName }]
    } , [])
  return listmarks
}

const initDataMarker = (data) => {
  const listmark = data.reduce(
    (res, row) => {
      const newPoint = setPos(row)  
      return [...res, { coord: newPoint, title: `${row.StationName}`, subTitle: `(↓В: ${row.incomeCount} / ↑И: ${row.outgoingCount}) `, code: row.StationCode, Lat: row.Lat, Lng: row.Lng, name: row.StationName }]
    } , [])
  return listmark
}
const rand = () => markersStandardImages[Math.floor(Math.random() * markersStandardImages.length)];
const ShowAzureMap = ({data,current,subdata,originsubdata,onSearchStation,
  fullmap,SetFullMap,onUpdCoordinates, showAllMarcers, deffilter}) => {
  
  const [markers, setMarkers] = useState([]);
  const [curmarker, setCurMarker] = useState([]);
  const [htmlMarkers, setHtmlMarkers] = useState([point4]);
  const [markersLayer] = useState('SymbolLayer');
  const [markerLayer] = useState('SymbolLayer');
  const [popupOptions, setPopupOptions] = useState({});
  const [popupProperties, setPopupProperties] = useState({});
  const [visPopup, setVisPopup] = useState(false);
  const [sizeFont, setSizeFont] = useState(0.01);
  const [sizeFontSub, setSizeFontSub] = useState(0.01);
  const { mapRef, isMapReady } = useContext(AzureMapsContext);

  const [curProperties, setCurProperties] = useState(null);
  const [getStationPos, setGetStationPos] = useState([]);

  useEffect(() => {
    setVisPopup(false);
    setMarkers(initDataMarkers(data))
  }, [data]) 
  useEffect(() => {
    setVisPopup(false);
    setCurMarker(initDataMarker([current]))
    const appVal = document.getElementById('app-val');
    appVal.innerHTML = current.Lat && current.Lng ? `${current.Lat}, ${current.Lng}` : ``
    const data = sessionStorage.getItem('data');
    if (data !== null)
    sessionStorage.setItem('data', null);
      
  }, [current]) 
  useEffect(() => {
    setVisPopup(false);
  }, [showAllMarcers]) 
  useEffect(() => {
    //console.log('curProperties========',popupProperties)
    if (!curProperties || curProperties?.code!==popupProperties?.code){
      setCurProperties(popupProperties)
      //onSearchStation(popupProperties)
    }
  }, [popupProperties]) 
  useEffect(() => {
    if (api.isNotEmptyArr(getStationPos)){
      //console.log('curProperties========',curProperties)
      onSearchStation(curProperties)
    }
  }, [getStationPos]) 
 

  const option = useMemo(() => {
    return {
      authOptions: {
        authType: AuthenticationType.subscriptionKey,
        subscriptionKey: key,
      },
      center: [25,49],
      zoom: 5,
      view: 'Auto'
    };
  }, []);

  const removeAllMarkers = () => {
    setMarkers([]);
    setHtmlMarkers([]);
  };

  const memoizedMarkerRender = useMemo(
    () => markers.map((marker) => renderPoint(marker)),
    [markers],
  );
  const memoizedCurMarkerRender = useMemo(
    () => curmarker.map((marker) => renderPoint(marker)),
    [curmarker],
  );
  function getStation(e) {
    setGetStationPos(e.position);
  }
  function getCoordinates(e) {
    if (e.map.getCamera().zoom >= 11.0) {
      setSizeFont(1.1)
      setSizeFontSub(0.9)
    }
    else if (e.map.getCamera().zoom > 7.0 && e.map.getCamera().zoom < 11.0){
      setSizeFont(0.75)
      setSizeFontSub(0.6)
    }
    else {
      setSizeFont(0.01)
      setSizeFontSub(0.01)
    }
  }
  const CalcInOut = (subdata) => {
    let InCargo = 0
    let OutCargo = 0
    subdata.map(row => { 
      if (row.napr == 1) InCargo++ 
      else
       if (row.napr == 2) OutCargo++ 
    })
    return `Итого: Входящих ${InCargo}, Исходящих ${OutCargo}`
  }
  
  return (
    <>
      <AzureMapsProvider>
        <div style={styles.map}>
          <AzureMap options={option} events={{ zoom: getCoordinates,click: (e) => {setVisPopup(false);getStation(e);} }}>
            <AzureMapDataSourceProvider
              events={{
                dataadded: (e) => {
                  //console.log('Data on source added', e);
                },
              }}
              id={'markers AzureMapDataSourceProvider'}
              options={{ cluster: true, clusterRadius: 2 }}
            >
              <AzureMapLayerProvider
                id={'markersExample AzureMapLayerProvider'}
                options={{
                  strokeColor: 'DarkOrchid',
                  strokeWidth: 3,
                  
                  iconOptions: {
                    image: "pin-blue",
                    size: 1.3,
                    allowOverlap: true,
                    ignorePlacement: true,
                    optional: true
                  },
                  textOptions: {
                    offset: [
                      0,
                      1.2
                    ],
                    allowOverlap: true,
                    
                    textField: [
                      'format',
          
                      //Bold the title property and scale its font size up.
                      ['get', 'title'],
                      {
                          'text-font': ['literal', ['SegoeFrutigerHelveticaMYingHei-Regular']],
                          'font-scale': sizeFont
                      },
          
                      '\n', {},   //Add a new line without any formatting.
          
                      //Scale the font size down of the subTitle property. 
                      ['get', 'subTitle'],
                      { 
                          'text-font': ['literal', ['SegoeFrutigerHelveticaMYingHei-Regular']],
                          'font-scale': sizeFontSub
                      }
                  ]
                  }
                }}
                events={{
                  contextmenu: (e) => {getStation(e)}, 
                  click: (e) =>  {
                    let prop  = e.shapes[0];
                    if (e.shapes  && e.shapes.length > 0)  {
                      prop  = e.shapes[0];
                      setPopupOptions({
                        ...popupOptions,
                        position: setPosPopur (prop),
                      pixelOffset: [0, -23]
                   });
                  
                
                      if (prop.data?.properties) {
                        setVisPopup(true);
                        setPopupProperties({
                          ...prop.data.properties.popUpProp
                        });
                      }
                    }

                    if (prop && prop.data && prop.data.properties.popUpProp){
                      const coord = prop.data.properties.popUpProp
                      const lng = coord.Lng   //Number(cord[0])
                      const lat = coord.Lat   //Number(cord[1]) 
                      e.map.setCamera({
                        center: [lng,lat],
                      });
                    }
                  },
                  
              }}
                lifecycleEvents={{
                  layeradded: () => {
                    //console.log('LAYER ADDED TO MAP');
                  },
                }}
                type={markersLayer}
              />
              {showAllMarcers && memoizedMarkerRender}
            </AzureMapDataSourceProvider>
            <AzureMapDataSourceProvider
              events={{
                dataadded: (e) => {
                  //console.log('Data on source added', e);
                },
              }}
              id={'curmarker AzureMapDataSourceProvider'}
              options={{ cluster: true, clusterRadius: 2 }}
            >
              <AzureMapLayerProvider
                id={'curmarker AzureMapLayerProvider'}
                options={{
                  strokeColor: 'DarkOrchid',
                  strokeWidth: 3,
                  iconOptions: {
                    image: "pin-red",
                    size: 1.3,
                    allowOverlap: true,
                    ignorePlacement: true,
                    optional: true
                  },
                  textOptions: {
                    offset: [
                      0,
                      1.2
                    ],
                    allowOverlap: true,
                    color: '#dd0707',
                    textField: [
                      'format',
          
                      ['get', 'title'],
                      {
                          'text-font': ['literal', ['SegoeFrutigerHelveticaMYingHei-Regular']],
                        'font-scale': showAllMarcers ? sizeFont : 1.1
                          
                      },
          
                      '\n', {},   //Add a new line without any formatting.
          
                      //Scale the font size down of the subTitle property. 
                      ['get', 'subTitle'],
                      { 
                          'text-font': ['literal', ['SegoeFrutigerHelveticaMYingHei-Regular']],
                          'font-scale': showAllMarcers ? sizeFontSub : 0.9
                      }
                     
                    ]
                    
                  }
                }}
                events={{
                  contextmenu: (e) => {getStation(e)}, 
                  click: (e) =>  {
                      let prop  = e.shapes[0];
                      if (e.shapes  && e.shapes.length > 0)  {
                        prop  = e.shapes[0];
                        setPopupOptions({
                          ...popupOptions,
                          position: setPosPopur (prop),
                        pixelOffset: [0, -18]
                    });
                    
                  
                        if (prop.data.properties) {
                          setVisPopup(true);
                          setPopupProperties({
                            ...prop.data.properties.popUpProp
                          });
                        }
                    }
                    
                    if (prop && prop.data && prop.data.properties.popUpProp){
                      const coord = prop.data.properties.popUpProp
                      const lng = coord.Lng   //Number(cord[0])
                      const lat = coord.Lat   //Number(cord[1]) 
                      //console.log('app-val cord', cord,lng,lat)
                      e.map.setCamera({
                        center: [lng,lat],
                      });
                    }
                  }, 
                  data: (e,current) => {
                    const appVal = document.getElementById('app-val');
                    const data = sessionStorage.getItem('data');
                    
                    if (data !== null)
                      if ( data == appVal.innerHTML) return
                    const koef = 5
                    let cord = appVal.innerHTML.split(',')
                    if (api.isNotEmptyArr(cord) && cord[0] != NaN && cord[1] != NaN && cord[0] != undefined && cord[1] != undefined) {
                      
                      const lng = Number(cord[0])
                      const lat = Number(cord[1]) 
                      e.map.setCamera({
                        center: [lat, lng],
                      });
                      sessionStorage.setItem('data', appVal.innerHTML);
                    }
                  },
                  
                }
                }
                    
                lifecycleEvents={{
                  layeradded: () => {
                    //console.log('LAYER ADDED TO MAP');
                  },
                  
                }}
                type={markerLayer}
              />
              {memoizedCurMarkerRender}
            </AzureMapDataSourceProvider>
              <AzureMapPopup
              isVisible={visPopup}
              options={popupOptions}
              popupContent={
                <ShowTable  
                  data={originsubdata.filter(el => el.kodstdis == popupProperties.code) }
                  title={`Станция: ${popupProperties.name}`} 
                  title2={`${popupProperties.code}`}
                  title3={`${CalcInOut(originsubdata.filter(el => el.kodstdis == popupProperties.code))}`}
                />
              }
            />
          </AzureMap>
        </div>
      </AzureMapsProvider>
    </>
  );
};

const styles = {
  map: {
    height: '100%',
  },
  buttonContainer: {
   display: 'flex',
   justifyContent: 'flex-end',
   width: '100%',
  },
  button: {
    height: 25,
    width: 180,
    backgroundColor: '#5a5757',
    marginRight: '15px'
  },
};

export default memo(ShowAzureMap);